import * as moment from "moment";
import * as _ from "underscore";

export class Utils {
    static loadpanel: DevExpress.ui.dxLoadPanel;

    public static fmtEmail(email: any): string {
        if (!email)
            return email;
        var pos = email.indexOf('@');
        if (pos > 0)
            return email.substring(0, pos - 1);
        else
            return email;
    }

    public static fmtDto(dato: any) {
        if (dato === null)
            return "";
        else {
            return moment(dato).format('DD.MM.YYYY hh:mm')
        }
    }

    public static fmtDateStr(date: string): string {
        if (!date || date.substring(0, 4) === "0001")
            return null;
        else
            return moment(new Date(date)).format("D.M.YYYY");
    }

    public static addNewTab(title: string, icon: string, tooltip?: string) {
        var close_title = "closeTab(event, '" + title + "')";
        $(".nav-tabs .active").removeClass('active');
        $(".tab-content .active").removeClass('active');
        var close = '<i onclick="javascript:' + close_title + '" class="fa btn-close fa-close" style="cursor:pointer;"></i>';
        $(".nav-tabs").append('<li role="presentation" class="active"><a href="#' + title +
            '" aria-controls="home" role="tab" data-toggle="tab" title="' + tooltip + '"><i class="fa mr-5 fa-' +
            icon + '"></i>' + title + close + '</a></li>');
        var cnt = '<div id="' + title + '"/></div>';
        $(".tab-content").append('<div role="tabpanel" class="tab-pane active pt-8" id="' + title + '">' + cnt + '</div>');
        $(".tab-content .active").fadeIn();
    }

    public static addIE(extra: number) {
        return this.isIE() ? extra : 0;
    }

    public static wait(txt?: string) {
        this.loadpanel = $("#prosess").dxLoadPanel({
            visible: false,
            shadingColor: "rgba(0,0,0,0.4)",
            message: txt ? txt : "Laster ned..."
        }).dxLoadPanel("instance");
        this.loadpanel.show();    
    }

    public static finished() {
        this.loadpanel.hide(); 
    }

    public static rowPrepare(info: any) {
        if (!info || !info.rowType || !info.data) {
            return;
        }
        if (info.rowType !== 'header') {
            if (info.data.utgaar)
                info.rowElement.addClass('utgatt');
            else if (info.data.ordreType && info.data.ordreType.navn === "EO")
                info.rowElement.addClass('erstatter');
            else if (info.data.erBatchJob)
                info.rowElement.addClass('batch');
        }    
    }

    public static rndId() {
        return Date.now().toString();
    }

    public static randomId(id: string) {
        let uniqid: string = Date.now().toString();
        return id + '_' + uniqid;
    }

    public static setDatasource(form: DevExpress.ui.dxForm, field: string, data: any) {
        let editor = <any>form.getEditor(field);
        editor.option("dataSource", data);
    }

    public static fixDates(obj: Object) {
        for (let key in obj) {
            if (obj[key] && obj[key].toUTCString) {
                obj[key] = obj[key].toUTCString();
            }
        }
    }

    public static getDateString(dato: Date): string {
        var dayname: string;
        switch (dato.getDay()) {
            case 0: dayname = 'søndag '; break;
            case 1: dayname = 'mandag '; break;
            case 2: dayname = 'tirsdag '; break;
            case 3: dayname = 'onsdag '; break;
            case 4: dayname = 'torsdag '; break;
            case 5: dayname = 'fredag '; break;
            case 6: dayname = 'lørdag '; break;
        }
        var month: string;
        switch (dato.getMonth()) {
            case 0: month = 'januar '; break;
            case 1: month = 'februar '; break;
            case 2: month = 'mars '; break;
            case 3: month = 'april '; break;
            case 4: month = 'mai '; break;
            case 5: month = 'juni '; break;
            case 6: month = 'july '; break;
            case 7: month = 'agust '; break;
            case 8: month = 'september '; break;
            case 9: month = 'oktoboer '; break;
            case 10: month = 'november '; break;
            case 11: month = 'desember '; break;
        }
        return dayname + dato.getDate() + ". " + month + dato.getFullYear();
    }

    public static colorDates() {
        var red_days = this.getRedDays();
        red_days.forEach((dato) => {
            var str = this.getDateString(dato);
            $("td.dx-calendar-cell[aria-label *= '" + str + "']").css('background-color', '#ffe6e6').click(() => {
                return true;
            });
        });
        $("td.dx-calendar-cell[aria-label *= 'lørdag']").css('background-color', '#ffe6e6').click(function () {
            return true;
        });
        $("td.dx-calendar-cell[aria-label *= 'søndag']").css('background-color', '#ffe6e6').click(function () {
            return true;
        });
    }

    public static getRedDaysFor(start: Date, end: Date): any[] {
        let result: any[] = [];
        var dato = new Date(start.toString());
        while (dato <= end) {
            let txt = this.isInvalidDate(dato);
            if (txt)
                result.push({ day: new Date(dato.toString()), txt: txt });
            dato.setDate(dato.getDate() + 1);
        }
        return result;
    }

    public static getRedDaysNy(): any[] {
        let result: any[] = [];
        var idag = new Date();
        const dato = new Date(new Date(idag).setMonth(idag.getMonth() - 6));
        const enddato = new Date(new Date(idag).setMonth(idag.getMonth() + 6));
        while (dato <= enddato) {
            let txt = this.isInvalidDate(dato);
            if (txt)
                result.push({ day: new Date(dato.toString()), txt: txt });
            dato.setDate(dato.getDate() + 1);
        }
        return result;
    }

    public static getRedDays(): Date[] {
        let result: Date[] = [];
        var idag = new Date();
        var dato = new Date(idag.getFullYear(), 0, 1, 0, 0, 0, 0);
        var enddato = new Date(idag.getFullYear(), 11, 31, 0, 0, 0, 0);
        while (dato <= enddato) {
            if (this.isInvalidDate(dato))
                result.push(new Date(dato.toString()));
            dato.setDate(dato.getDate() + 1);
        }
        return result;
    }

    public static nextValid(date: Date): Date {
        let ans = new Date(date.toString());
        while (this.isInvalidDate(ans)) {
            ans.setDate(ans.getDate() + 1);
        }
        return ans;
    }

    public static isInvalidDate(date: Date): any {
        let easter = this.getEaster(date.getFullYear());
        let easterMonday = new Date(easter);
        easterMonday.setDate(easter.getDate() + 1);
        let goodFriday = new Date(easter);
        goodFriday.setDate(easter.getDate() - 2);
        let maundyThursday = new Date(easter);
        maundyThursday.setDate(easter.getDate() - 3);
        let palmSunday = new Date(easter);
        palmSunday.setDate(easter.getDate() - 7);
        let whitSunday = new Date(easter);
        whitSunday.setDate(easter.getDate() + 49);
        let whitMandag = new Date(easter);
        whitMandag.setDate(easter.getDate() + 50);
        let ascensionDay = new Date(easter);
        ascensionDay.setDate(easter.getDate() + 39);

        if (date.getDate() === 1) {
            if (date.getMonth() === 4) {
                return "Første mai";
            } else if (date.getMonth() === 0) {
                return "Første nyttårsdag";
            }
        } else if (date.getMonth() === 4 && date.getDate() === 17) {
            return "17. mai";
        } else if (date.getMonth() === 11) {
            if (date.getDate() === 25) {
                return "Første juledag";
            } else if (date.getDate() === 26) {
                return "Andre juledag";
            }
        } else if (this.isSameDate(date, easter)) {
            return "Første påskedag";
        } else if (this.isSameDate(date, easterMonday)) {
            return "Andre påskedag";
        } else if (this.isSameDate(date, goodFriday)) {
            return "Langfredag";
        } else if (this.isSameDate(date, maundyThursday)) {
            return "Skjærtorsdag";
        } else if (this.isSameDate(date, palmSunday)) {
            return "Palm søndag";
        } else if (this.isSameDate(date, whitSunday)) {
            return "Første pinsedag";
        } else if (this.isSameDate(date, whitMandag)) {
            return "Andre pinsedag";
        } else if (this.isSameDate(date, ascensionDay)) {
            return "Kristi himmelfartsdag";
        }

        if (date.getDay() === 0) {
            return "Søndag";
        } else if (date.getDay() === 6) {
            return "Lørdag";
        }
        return false;
    }

    public static  getEaster(year) {
        "use strict";
        var a, k, m, d, s, r, og, sz, oe, os, date;
        date = new Date(year, 2, 1, 0, 0);

        // Moon parameter
        a = year % 19;
        // Secular number
        k = Math.floor(year / 100);

        // Secular Moon shift
        m = 15 + Math.floor((3 * k + 3) / 4) - Math.floor((8 * k + 13) / 25);
        // Seed for 1st full Moon in spring
        d = (19 * a + m) % 30;
        // Secular sun shift
        s = 2 - Math.floor((3 * k + 3) / 4);
        // Calendarian correction quantity
        r = Math.floor((d + Math.floor(a / 11)) / 29);
        // Easter limit
        og = 21 + d - r;

        // 1st sunday in March
        sz = 7 - (year + Math.floor(year / 4) + s) % 7;
        // Distance Easter sunday from Easter limit in days
        oe = 7 - (og - sz) % 7; // Distance Easter sunday from Easter limit in days
        // Easter sunday as number of days in March
        os = (og + oe);

        // Convert to dare
        date.setDate(date.getDate() + os - 1);

        return date;
    }

    public static sameNoTime(date1: Date, date2: Date) {

        return moment(date1).format('LL') === moment(date2).format('LL');
    }

    public static isSameDate(date1: Date, date2: Date) {
        return date1.toDateString() === date2.toDateString();
    }

    public static isIE(): any {
        var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    }
}


// WEBPACK FOOTER //
// ./TS/Utils.ts